<script setup>
    import { inject } from 'vue';
    import stubLogo from '@client/svg/stub-logo.svg?raw';
    import CartWidget from './CartWidget.vue';
    let rootData = inject('rootData');
</script>

<template>
    <div class="header">
    <div class="container">
      <div v-if="rootData.view?.logo" class="logo">
        <img :src="rootData.view?.logo" alt="store logo" loading="lazy" decoding="async">
      </div>
      <div v-else v-html="stubLogo" class="logo logoStub"></div>
      <div class="contact-info">
        <a v-if="rootData?.phone" :href="'tel:'+ rootData?.phone" class="btn--phone">
          <svg class="icon" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.9 14.98A14.03 14.03 0 0 1 2.27 6.9 13.4 13.4 0 0 1 1 2.06a.94.94 0 0 1 .26-.76A1 1 0 0 1 2 .98h2.83c.24 0 .44.07.62.2.17.15.29.33.34.57l.5 2.23c.03.17.02.33-.02.5a.94.94 0 0 1-.25.44L4 6.96a12.68 12.68 0 0 0 5 5l2.06-2a.9.9 0 0 1 .46-.26c.17-.04.33-.04.48-.01l2.23.48c.23.05.42.17.56.35a1 1 0 0 1 .21.63v2.83c0 .37-.13.64-.4.8-.26.14-.5.21-.7.2Z" fill="currentColor"></path>
          </svg>
        </a>
      </div>
      <div v-show="!rootData?.ordering?.catalog" class="cart-container">
        <CartWidget/>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.header {
  background-color: var(--c-primary);
  color: #fff;
  z-index: 60;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
  text-decoration: none;
  top: 0;
  left: 0;
  height: 61px;
  position: relative;

  @media (min-width: 1280px) {
      position: sticky;
  }

  .container {
    display: flex;
    justify-content: space-between;
    height: 100%;
  }

  // & ~ section {
  //   margin-top: 61px;
    
  //   @media (min-width: 1280px) {
  //     margin-top: 72px;
  //   }
  // }

  .logo {
      height: 100%;
      width: auto;
      align-self: center;
      padding: 0.75rem 0;

      img {
        max-width: 100%;
        max-height: 100%;
      }

      &Stub {
        display: flex;
        align-items: center;
        svg {
          display: block;
          width: 72px;
          height: auto;
          color: #FFFFFF;

          @media (min-width: 1280px) {
            width: 86px;
          }

        }
      }
  }

  .contact-info {
    margin-left: auto;
    margin-right: var(--size-xs);
    padding: .75rem 0;
    display: flex;
    align-items: center;

    & > :not(:last-child) {
      margin-right: var(--size-xs);
    }

    @media (min-width: 1280px) {
        display: none;
    }

    .btn--phone {
      color: var(--c-primary);
      background-color: #fff;
      box-shadow: 0 0 5px #00000040;
      width: var(--size-xl);
      height: var(--size-xl);
      line-height: 1;
      font-size: 0.75rem;
      border-radius: var(--rounded-full);
      text-align: center;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      margin-left: auto;
    }
  }
  
  @media (min-width: 1280px) {
      height: 72px;
      .cart-container {
        position: relative;
        width: 270px;
      }
  }

  /* Fix admin bar issues */
  .admin-bar & {
    top: 46px;

    @media (min-width: 600px) {
      top: 46px;
    }

    @media (min-width: 783px) {
      top: 32px;
    }

    &.sticky {
      top: 0;

      @media (min-width: 783px) {
        top: 32px;
      }
    }
  }
}

body.admin-bar {
  transition: margin-top 0.1s 0s linear;
    // @media (min-width: 783px) {
    @media (min-width: 1280px) {
      margin-top: 32px;
      // hack
      &[style*="overflow"] {
        margin-top: 0;
      }
    }
}
#wpadminbar#wpadminbar {
  z-index: 999 !important;
}
</style>
